import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import CommentsList from './comments_list'
import CommentListControls from './comment_list_controls'

export default class CommentModeration extends Component {
  handleSelect = (commentId, selected) => {
    const { onSelectionChange } = this.props
    onSelectionChange(commentId, selected)
  }

  handleSelectAllClick = () => {
    const { selectedCommentIds, comments } = this.props
    if (comments.length > 0) {
      selectedCommentIds.length === 0 ? this.selectAll() : this.deselectAll()
    }
  }

  handleSelectVisible = () => {
    const { comments, onSelectVisible } = this.props
    onSelectVisible(comments)
  }

  handleSelectHidden = () => {
    const { comments, onSelectHidden } = this.props
    onSelectHidden(comments)
  }

  selectAll() {
    const { comments, onSelectAll } = this.props
    onSelectAll(comments)
  }

  deselectAll() {
    const { comments, onDeselectAll } = this.props
    onDeselectAll(comments)
  }

  handleShowSelected = () => {
    const { selectedCommentIds, onShowSelected } = this.props
    onShowSelected(selectedCommentIds)
  }

  handleHideSelected = () => {
    const { selectedCommentIds, onHideSelected } = this.props
    onHideSelected(selectedCommentIds)
  }

  render() {
    const { comments, selectedCommentIds, awaitingBulkShowAsyncResponse, awaitingBulkHideAsyncResponse } = this.props
    const anySelected = selectedCommentIds.length > 0
    const allSelected = anySelected && comments.length === selectedCommentIds.length
    return (
      <>
        <CommentListControls
          comments={comments}
          anySelected={anySelected}
          allSelected={allSelected}
          onClickSelectAllCheckBox={this.handleSelectAllClick}
          onSelectVisible={this.handleSelectVisible}
          onSelectHidden={this.handleSelectHidden}
          onShowSelected={this.handleShowSelected}
          onHideSelected={this.handleHideSelected}
          awaitingBulkShowAsyncResponse={awaitingBulkShowAsyncResponse}
          awaitingBulkHideAsyncResponse={awaitingBulkHideAsyncResponse}
        />
        <CommentsList comments={comments} selectedIds={selectedCommentIds} onSelect={this.handleSelect} />
      </>
    )
  }
}
CommentModeration.propTypes = {
  comments: PropTypes.array.isRequired,
  selectedCommentIds: PropTypes.array.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
  onSelectVisible: PropTypes.func.isRequired,
  onSelectHidden: PropTypes.func.isRequired,
  onShowSelected: PropTypes.func.isRequired,
  onHideSelected: PropTypes.func.isRequired,
  awaitingBulkShowAsyncResponse: PropTypes.bool.isRequired,
  awaitingBulkHideAsyncResponse: PropTypes.bool.isRequired,
}
CommentModeration.defaultProps = {
  comments: [],
  selectedCommentIds: [],
  onSelectionChange: noop,
  onSelectAll: noop,
  onDeselectAll: noop,
  onSelectVisible: noop,
  onSelectHidden: noop,
  onShowSelected: noop,
  onHideSelected: noop,
  awaitingBulkShowAsyncResponse: false,
  awaitingBulkHideAsyncResponse: false,
}
